/*
 * 呼び出しコード検索用コンポーネント
 */
<template>
<div class="calling-code-search" >
	<div v-if="r_title" class="name">
		{{r_title}}
	</div>
	<div>
		<el-form class="text_code_area" :model="m_ruleForm" :rules="m_validationCode" ref="valid_target">
			<el-form-item prop="from" class="text_code">
				<c-inputedit
					class="input-num"
					:r_input_class="input_from_class"
					v-model="m_ruleForm.from"
					r_type="number"
					:r_disabled="r_disabled"
					:r_placeholder="getZeroPaddingString"
					:r_max_length="code_max_len"
					:r_mask="r_code_mask"
					:r_text_footer="r_text_footer_from"
					@change="onChange"
					@blur="onBlurFrom"
				></c-inputedit>
			</el-form-item>
			<div class="text_code_conect">～</div>
			<el-form-item prop="to" class="text_code">
				<c-inputedit
					class="input-num"
					:r_input_class="input_to_class"
					v-model="m_ruleForm.to"
					r_type="number"
					:r_disabled="r_disabled"
					:r_placeholder="getZeroPaddingString"
					:r_max_length="code_max_len"
					:r_mask="r_code_mask"
					:r_text_footer="r_text_footer_to"
					@change="onChange"
					@blur="onBlurTo"
				></c-inputedit>
			</el-form-item>
		</el-form >
	</div>
	<div class="clearfix"></div>
</div>
</template>
<script>
// 定数ファイル読み込み
import {MAX_CODE_DEFAULT} from 'js/const/constants';
import {MIN_CODE_DEFAULT} from 'js/const/constants';

	export default {
		mixins: [
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		props: {
			'r_default': {
				type:Object,
				default: function(){return {from: "", to: ""};}
			},
			'r_title':String,
			'r_code_max':{
				type:[Number,String],
				default:MAX_CODE_DEFAULT
			},
			'r_code_min':{
				type:[Number,String],
				default:MIN_CODE_DEFAULT
			},
			'r_is_code_regard_as_string': {	// 入力された数値を文字列としてバリデートするかどうか
				type: Boolean,
				default: false
			},
			'r_validator':null,//!< validate 処理を変更したい場合に指定する。指定がなければデフォルトチェックが有効になる
			'r_is_disp_update':{
				type:Boolean,
				default:false//!< 更新を明示するか？
			},
			'r_code_mask':null,
			'r_text_footer_from': {
				type: String,
				default: ''
			},
			'r_text_footer_to': {
				type: String,
				default: ''
			},
			'r_disabled': {
				type:Boolean,
				default:false
			},
		},
		data: function (){
			var target = this;
			return{
				m_ruleDefault: {from: "", to: ""},
				m_ruleForm:  {from: "", to: ""},
				m_validationCode:  {
					// from: [
					// 	{
					// 		validator: (rule, value, callback) => {
					// 			var fnValidate = (target.r_validator)?target.r_validator:target.validateType;

					// 			let errMessage = '';
					// 			if(this.r_is_code_regard_as_string){
					// 				const max = this.r_code_max + '';
					// 				const min = this.r_code_min + '';
					// 				errMessage = fnValidate([target.CHKTYPE_NUMBER, target.CHKTYPE_CODE_STRING], value, max, min);
					// 			}else{
					// 				errMessage = fnValidate([target.CHKTYPE_NUMBER, target.CHKTYPE_CODE], value, Number(target.r_code_max), Number(target.r_code_min));
					// 			}

					// 			if ( errMessage.length > 0 ) {
					// 				callback(new Error(errMessage));
					// 			} else {
					// 				callback();
					// 			}
					// 		},
					// 		trigger: 'blur'
					// 	},
					// ],
					// to: [
					// 	{
					// 		validator: (rule, value, callback) => {
					// 			var fnValidate = (target.r_validator)?target.r_validator:target.validateType;

					// 			let errMessage = '';
					// 			if(this.r_is_code_regard_as_string){
					// 				const max = this.r_code_max + '';
					// 				const min = this.r_code_min + '';
					// 				errMessage = fnValidate([target.CHKTYPE_NUMBER, target.CHKTYPE_CODE_STRING], value, max, min);
					// 			}else{
					// 				errMessage = fnValidate([target.CHKTYPE_NUMBER, target.CHKTYPE_CODE], value, Number(target.r_code_max), Number(target.r_code_min));
					// 			}

					// 			if(errMessage.length == 0 && target.m_ruleForm.from != '' && value != ''){
					// 				// FromとToの逆転をチェックする
					// 				if(this.r_is_code_regard_as_string){
					// 					if(String(target.m_ruleForm.from).padStart(target.code_max_len, '0') > String(value).padStart(target.code_max_len, '0')){
					// 						errMessage = target.msg_err.from_to_reverse;
					// 					}
					// 				}else{
					// 					if(Number(target.m_ruleForm.from) > Number(value)){
					// 						errMessage = target.msg_err.from_to_reverse;
					// 					}
					// 				}
					// 			}

					// 			if ( errMessage.length > 0 ) {
					// 				callback(new Error(errMessage));
					// 			} else {
					// 				callback();
					// 			}
					// 		},
					// 		trigger: 'blur'
					// 	},
					// ],
				},
			}
		},
		created: function () {
			this.$on('event_clear', this.setClear);
		},
		computed: {
			getZeroPaddingString: function(){
				return ('0000000000000000000' + 0).slice(-this.code_max_len);
			},
			code_max_len:function(){
				if(typeof this.r_code_max == 'string'){
					return this.r_code_max.length;
				}
				return this.r_code_max.toString().length;
			},
			input_from_class:function(){
				if(this.r_is_disp_update == false )return "";
				if(this.m_ruleDefault["from"] != this.m_ruleForm["from"])return this.UPDATING_COL;
				return "";
			},
			input_to_class:function(){
				if(this.r_is_disp_update == false )return "";
				if(this.m_ruleDefault["to"] != this.m_ruleForm["to"])return this.UPDATING_COL;
				return "";
			},
			UPDATING_COL: function( ) {
				return "updating_col";
			},

		},
		mounted:function(){
			if(this.r_default["from"] != null && this.r_default["to"] != null){
				this.setParam(this.r_default["from"], this.r_default["to"]);
			}
		},
		watch:{
			r_default: function(){
				if(this.r_default["from"] != null && this.r_default["to"] != null){
					this.setParam(this.r_default["from"], this.r_default["to"]);
				}
			}
		},
		methods: {
			checkUpdate:function(){
				if(this.r_is_disp_update == false )return false;
				if(this.m_ruleDefault["from"] != this.m_ruleForm["from"] ||
					this.m_ruleDefault["to"] != this.m_ruleForm["to"])return true;
				return false;
			},
			setClear: function () {
				this.clearMessage();
				this.m_ruleForm.from = this.m_ruleDefault.from;
				this.m_ruleForm.to = this.m_ruleDefault.to;

				this.$emit('input', this.m_ruleForm);
			},
			onBlurFrom: function(e){
				this.validate();
				this.$emit('blur');
			},
			onBlurTo: function(e){
				this.validate();
				this.$emit('blur');
			},
			getParam: function( ){
				return this.m_ruleForm;
			},
			setParam(from, to){
				this.m_ruleForm.from = from;
				this.m_ruleForm.to = to;
			},
			onChange:function(e){
console.log("m_ruleForm");
console.log(this.m_ruleForm);
console.log(this.m_ruleDefault);
				this.$emit('input', this.m_ruleForm);
				this.$emit('change');
			}
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/parts_com/search/editCodeFromTo.vue